module.exports = __webpack_public_path__ + "static/media/icon-clock-blue.31014a27.svg";